import { useDateFormat } from '../hooks/useDateFormat';
import { IDateValueFormatter } from '../interfaces';

export const DateValueFormatter = ({
  value,
  timeZone,
  template,
}: IDateValueFormatter) => {
  const normalizedValue = value ?? undefined;
  const dateFormat = useDateFormat({ timeZone, template });
  return dateFormat(normalizedValue);
};
